/**
 * Visa category metadata — language-neutral.
 *
 * The display `code` (e.g. "EB-1", "L VISA") is kept verbatim across locales:
 * these are statutory category designators, not translatable marketing copy.
 * All human-readable descriptive text lives in `src/lib/content.ts`
 * (`VISA_TEXT`) as lazy Paraglide message thunks, keyed by `VisaId`, and is
 * resolved in component render scope.
 */

export type VisaId = 'eb1' | 'eb2niw' | 'eb3' | 'eb4' | 'eb5' | 'l1' | 'o1' | 'e2';

export interface VisaMeta {
	id: VisaId;
	code: string;
	anchorId: string;
	theme: 'light' | 'dark';
}

/** Display order of the visa categories on the home grid and the services page. */
export const VISA_ORDER: VisaId[] = ['eb1', 'eb2niw', 'eb3', 'eb4', 'eb5', 'l1', 'o1', 'e2'];

export const VISA_META: Record<VisaId, VisaMeta> = {
	eb1: { id: 'eb1', code: 'EB-1', anchorId: 'visa-eb1', theme: 'light' },
	eb2niw: { id: 'eb2niw', code: 'EB-2 NIW', anchorId: 'visa-eb2-niw', theme: 'dark' },
	eb3: { id: 'eb3', code: 'EB-3', anchorId: 'visa-eb3', theme: 'light' },
	eb4: { id: 'eb4', code: 'EB-4', anchorId: 'visa-eb4', theme: 'dark' },
	eb5: { id: 'eb5', code: 'EB-5', anchorId: 'visa-eb5', theme: 'light' },
	l1: { id: 'l1', code: 'L-1', anchorId: 'visa-l1', theme: 'dark' },
	o1: { id: 'o1', code: 'O-1', anchorId: 'visa-o1', theme: 'light' },
	e2: { id: 'e2', code: 'E-2', anchorId: 'visa-e2', theme: 'light' }
};
